import type { FC } from "react";
import React from "react";

import { IconSizeErrorBoundary } from "../../../../HOCs/IconSizeErrorBoundary";
import { Icon } from "../../../Icon";

import type { IconProps } from "../../../Icon";
import type { IPictureBase } from "../../types";

const PICTURE_ICON_TEST_ID = "picture-icon-test-id";

interface IPictureIconMain {
    size: IconProps["size"];
    pictureSize: Exclude<IPictureBase["size"], undefined>;
}

interface IPictureIcon extends Pick<IconProps, "icon"> {}

export const PictureIcon: FC<IPictureIcon> = (_props) => {
    const props = _props as IPictureIcon & IPictureIconMain;
    const { icon, size, pictureSize } = props;

    return (
        <IconSizeErrorBoundary
            componentName="Picture"
            componentSize={pictureSize}
            iconName={icon}
            iconSize={size}
        >
            <Icon {...(props as IconProps)} data-tsid={PICTURE_ICON_TEST_ID} />
        </IconSizeErrorBoundary>
    );
};

PictureIcon.displayName = "Picture.Icon";

export default PictureIcon;
